<template>
  <div class="go-sheet-overlay" @click.self="onDismiss">
    <div class="go-sheet">
      <div class="go-sheet-handle"></div>
      <span class="go-sheet-badge">{{ $vuetify.t('$vuetify.groupOrder.tooltipBadgeNew') }}</span>
      <div class="go-sheet-title">{{ $vuetify.t('$vuetify.groupOrder.sheetTitle') }}</div>
      <div class="go-sheet-subtitle">{{ $vuetify.t('$vuetify.groupOrder.sheetSubtitle') }}</div>

      <div class="go-sheet-art">
        <div class="go-sheet-avatars">
          <span class="go-sheet-avatar go-sheet-avatar-1">T</span>
          <span class="go-sheet-avatar go-sheet-avatar-2">M</span>
          <span class="go-sheet-avatar go-sheet-avatar-3">A</span>
        </div>
        <span class="go-sheet-dashes"></span>
        <span class="go-sheet-cart">
          <svg viewBox="0 0 24 24" width="20" height="20" fill="none" stroke="#17181a" stroke-width="1.7" stroke-linecap="round"><circle cx="9.5" cy="19.5" r="1.4"></circle><circle cx="16.5" cy="19.5" r="1.4"></circle><path d="M3.5 4.5h2.2l2.2 11h9.3l1.9-7.6H6.4"></path></svg>
          <span class="go-sheet-cart-count">3</span>
        </span>
      </div>

      <div class="go-sheet-bullets">
        <div class="go-sheet-bullet-row">
          <span class="go-sheet-bullet-icon">
            <svg viewBox="0 0 24 24" width="16" height="16" fill="none" stroke="#17181a" stroke-width="1.7" stroke-linecap="round"><circle cx="12" cy="12" r="8"></circle><path d="M12 7.5V12l3 2"></path></svg>
          </span>
          <span class="go-sheet-bullet-text">{{ $vuetify.t('$vuetify.groupOrder.sheetBullet1') }}</span>
        </div>
        <div class="go-sheet-bullet-row">
          <span class="go-sheet-bullet-icon">
            <svg viewBox="0 0 24 24" width="16" height="16" fill="none" stroke="#17181a" stroke-width="1.7" stroke-linecap="round"><rect x="3" y="5.5" width="18" height="13" rx="2.5"></rect><path d="M3 10h18"></path></svg>
          </span>
          <span class="go-sheet-bullet-text">{{ $vuetify.t('$vuetify.groupOrder.sheetBullet2') }}</span>
        </div>
        <div class="go-sheet-bullet-row">
          <span class="go-sheet-bullet-icon">
            <svg viewBox="0 0 24 24" width="16" height="16" fill="none" stroke="#17181a" stroke-width="1.7" stroke-linecap="round"><path d="M9.5 14.5 14.5 9.5"></path><path d="M11 6.8l1.9-1.9a3.6 3.6 0 0 1 5.2 5.2L16.2 12"></path><path d="M13 17.2l-1.9 1.9a3.6 3.6 0 0 1-5.2-5.2L7.8 12"></path></svg>
          </span>
          <span class="go-sheet-bullet-text">{{ $vuetify.t('$vuetify.groupOrder.sheetBullet3') }}</span>
        </div>
      </div>

      <button class="go-sheet-start-btn" @click="onStart">{{ $vuetify.t('$vuetify.groupOrder.tooltipStartBtn') }}</button>
      <button class="go-sheet-notnow-btn" @click="onDismiss">{{ $vuetify.t('$vuetify.groupOrder.sheetNotNowBtn') }}</button>
    </div>
  </div>
</template>

<script>
export default {
  name: 'GroupOrderOnboardingSheet',
  methods: {
    onStart() {
      this.$emit('start');
    },
    onDismiss() {
      this.$emit('dismiss');
    }
  }
};
</script>

<style scoped>
@keyframes goSheetFadeIn { from { opacity: 0; } }
@keyframes goSheetUp { 0% { opacity: 0; transform: translateY(70px); } 100% { opacity: 1; transform: translateY(0); } }
@keyframes goSheetJoinLoop {
  0% { opacity: 0; transform: translateX(-16px) scale(.6); }
  14% { opacity: 1; transform: translateX(0) scale(1); }
  80% { opacity: 1; transform: translateX(0) scale(1); }
  94% { opacity: 0; transform: translateX(0) scale(.9); }
  100% { opacity: 0; }
}

.go-sheet-overlay {
  position: fixed;
  inset: 0;
  z-index: 200;
  background: rgba(16, 17, 18, .5);
  display: flex;
  align-items: flex-end;
  justify-content: center;
  animation: goSheetFadeIn .25s both;
}
.go-sheet {
  width: 100%;
  max-width: 460px;
  box-sizing: border-box;
  background: #fff;
  border-radius: 22px 22px 0 0;
  padding: 10px 20px calc(40px + env(safe-area-inset-bottom));
  animation: goSheetUp .45s cubic-bezier(.2,.8,.2,1) both;
}
.go-sheet-handle {
  width: 36px;
  height: 4px;
  background: #d9dbdd;
  border-radius: 999px;
  margin: 2px auto 14px;
}
.go-sheet-badge {
  display: inline-block;
  background: var(--v-primary-base);
  color: #fff;
  font-size: 10px;
  font-weight: 700;
  letter-spacing: 1.2px;
  border-radius: 999px;
  padding: 4px 9px;
}
.go-sheet-title {
  font-size: 20px;
  font-weight: 700;
  margin-top: 10px;
  color: #17181a;
}
.go-sheet-subtitle {
  font-size: 13.5px;
  color: #6f7377;
  margin-top: 4px;
  line-height: 1.5;
}

.go-sheet-art {
  margin-top: 14px;
  height: 104px;
  background: #f6f7f8;
  border: 1px solid #eceded;
  border-radius: 14px;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 16px;
}
.go-sheet-avatars { display: flex; }
.go-sheet-avatar {
  width: 34px;
  height: 34px;
  border-radius: 999px;
  color: #fff;
  font-size: 13px;
  font-weight: 700;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  border: 3px solid #f6f7f8;
}
.go-sheet-avatar-1 { background: var(--v-primary-base); animation: goSheetJoinLoop 3.6s ease infinite; }
.go-sheet-avatar-2 { background: #3c4043; margin-left: -10px; animation: goSheetJoinLoop 3.6s ease .4s infinite; }
.go-sheet-avatar-3 { background: #6d7175; margin-left: -10px; animation: goSheetJoinLoop 3.6s ease .8s infinite; }
.go-sheet-dashes {
  width: 26px;
  border-top: 2px dashed #c9cccf;
}
.go-sheet-cart {
  position: relative;
  width: 46px;
  height: 46px;
  background: #fff;
  border: 1px solid #e3e4e6;
  border-radius: 999px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
}
.go-sheet-cart-count {
  position: absolute;
  top: -5px;
  right: -5px;
  width: 18px;
  height: 18px;
  background: var(--v-primary-base);
  color: #fff;
  border-radius: 999px;
  font-size: 10.5px;
  font-weight: 700;
  display: inline-flex;
  align-items: center;
  justify-content: center;
}

.go-sheet-bullets {
  display: flex;
  flex-direction: column;
  margin-top: 12px;
}
.go-sheet-bullet-row {
  display: flex;
  align-items: center;
  gap: 12px;
  min-height: 44px;
}
.go-sheet-bullet-icon {
  width: 34px;
  height: 34px;
  border-radius: 999px;
  background: #f1f2f3;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  flex: none;
}
.go-sheet-bullet-text {
  font-size: 13.5px;
  font-weight: 600;
  color: #17181a;
}

.go-sheet-start-btn {
  margin-top: 10px;
  width: 100%;
  height: 50px;
  background: var(--v-primary-base);
  color: #fff;
  border: none;
  border-radius: 999px;
  font-size: 15px;
  font-weight: 600;
  cursor: pointer;
}
.go-sheet-start-btn:hover { opacity: .92; }
.go-sheet-notnow-btn {
  margin-top: 2px;
  width: 100%;
  height: 44px;
  background: none;
  border: none;
  font-size: 13.5px;
  font-weight: 600;
  color: #6f7377;
  cursor: pointer;
}
</style>
